import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxPermissionsService } from 'ngx-permissions';
import { ModalOpenApplicationComponent } from 'src/app/modal-open-application/modal-open-application.component';
import { AuthService } from 'src/app/shared/auth.service';
import { environment } from 'src/environments/environment';
import { SoftwareModalComponent } from '../modals/software-modal/software-modal.component';

@Component({
  selector: 'app-softwares',
  templateUrl: './softwares.component.html',
  styleUrls: ['./softwares.component.scss'],
})
export class SoftwaresComponent implements OnInit {
  @Input() haveLateralName: boolean = false;

  baseUrl: string = environment.baseUrl;
  accessToken: string | null ;

  constructor(
    public authService: AuthService,
    public dialog: MatDialog,
    public ngxPermissionService: NgxPermissionsService
  ) {}

  ngOnInit(): void {

    this.accessToken = localStorage.getItem('access_token');
  }

  openGuia() {
    const token = this.getAccessToken();

    if (token) {
      location.href =
        'https://guia.techfinance.com.br/token-callback.html?token=' +
        encodeURIComponent(token);
      return;
    }

    location.href = 'https://guia.techfinance.com.br/';
  }

  openModal(application: 'dashplan') {
    const params = {
      application,
    };

    this.dialog.open(SoftwareModalComponent, {
      data: params,
    });
  }

  openApplication(application: 'apolo' | 'guia' | 'oraculo' | 'dashplan') {
    const params = {
      application,
    };

    const permissions = this.ngxPermissionService.getPermissions();
    if (permissions['members::list::my'] == undefined) {
      location.href = environment.clientRedirect
        .replace('techfinance', application + '.techfinance')
      return;
    }

    this.dialog.open(ModalOpenApplicationComponent, {
      data: {
        application: params.application,
        panelClass: 'custom-dialog-container',
      },
    });
  }

  private getAccessToken(): string | null {
    const localStorageToken = localStorage.getItem('access_token');
    if (localStorageToken) {
      return localStorageToken;
    }

    try {
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);

        if (key && key.indexOf('_authzData') !== -1) {
          let value = sessionStorage.getItem(key);

          if (value) {
            try {
              value = JSON.parse(value);
            } catch (e) {}

            if (typeof value === 'string' && value.length > 10) {
              return value;
            }
          }
        }
      }
    } catch (e) {}

    return null;
  }
}
